module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n	<div class="body__header">\n		<div class="body-header__title">Schedule</div>\n		<div class="body-header__options">\n			';
 if (userHasRole(['super','admin'])) { 
__p+='\n				<a class="m-btn js-add  m-btn--primary">add schedule</a>\n			';
 } 
__p+='\n		</div>\n	</div>\n	<div class="body__content schedule-region"></div>\n\n\n\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/schedules/list/templates/layout.html
// module id = 465
// module chunks = 0